import format from 'string-template';

import { HistoryEventType } from '../../../../../Model/CoachHistory';
import { DateFormat, timeStampToStr } from '../../../../../../utils/date';
import texts from './texts';

const getCoachHistoryInfo = (doc) => {
  const meta = doc.metadata;

  const value = format(
    texts.eventText[doc.type] ?? doc.type,
    {
      status: meta?.newValue ? texts.statusText.enabled : texts.statusText.disabled,
      camAction: meta?.newValue ? texts.camActionTexts.added : texts.camActionTexts.removed,
    },
  );

  let actionInfo = '';
  if (meta) {
    if (doc.type === HistoryEventType.LAUNCH_DATE_EDITED) {
      actionInfo = format(texts.launchDateChange, {
        newLaunchDate: meta.newLaunchDate ? timeStampToStr(meta.newLaunchDate, DateFormat.DATE_FORMAT_COMMA) : '-',
        oldLaunchDate: meta.oldLaunchDate ? timeStampToStr(meta.oldLaunchDate, DateFormat.DATE_FORMAT_COMMA) : '-',
      });
    } else if (doc.type === HistoryEventType.CAM_ASSIGNMENT_UPDATED) {
      actionInfo = !meta.newValue
        ? format(texts.camActionNote.removed, { userName: meta.previousValue?.userName })
        : format(texts.camActionNote.added, { userName: meta.newValue?.userName });
    }
  }

  return { value, actionInfo };
};

export {
  getCoachHistoryInfo,
};
